
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { DateTimePicker } from '@syncfusion/ej2-calendars';
import { ChangeEventArgs } from '@syncfusion/ej2-calendars';
import { EventSettingsModel,EJ2Instance, PopupOpenEventArgs,  RecurrenceEditor,
  ResizeService, DragAndDropService,ScheduleComponent, ActionEventArgs,  YearService, CellClickEventArgs, ResourceDetails, WorkHoursModel, EventRenderedArgs } from '@syncfusion/ej2-angular-schedule';
import { DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService} from '@syncfusion/ej2-angular-schedule';
import { Grid } from '@syncfusion/ej2-angular-grids';
import { Query,  DataManager, ReturnOption } from '@syncfusion/ej2-data';
import {L10n, setCulture,loadCldr} from '@syncfusion/ej2-base';
import { DragAndDropEventArgs, TreeViewComponent } from '@syncfusion/ej2-angular-navigations';
import { closest, remove, addClass } from '@syncfusion/ej2-base';
import { ApiService } from 'src/app/_services/api.service';


setCulture('it');
import * as numberingSystems from 'src/assets/cldr-data/it/numberingSystems.json';
import * as gregorian from 'src/assets/cldr-data/it/ca-gregorian.json';
import * as numbers from 'src/assets/cldr-data/it/numbers.json';
import * as timeZoneNames from  'src/assets/cldr-data/it/timeZoneNames.json';
import { GlobalService } from 'src/app/_services/global.service';

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
L10n.load({
  it: {
    calendar: {
              today:"Today"
    },
    datetimepicker: {
      today:"Today"
    },
    schedule: {
      saveButton: 'Save',
      cancelButton: 'Close',
      deleteButton: 'Remove',
      newEvent: 'Add Event',
    }
  }
});
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DayService,  WorkWeekService, MonthService,YearService, ResizeService
  ],

})
export class CalendarComponent implements OnInit {
  
  @ViewChild('schedule') public scheduleObj?: ScheduleComponent;
  public eventSettings: EventSettingsModel = {
    allowEditing:false,
    dataSource: []
  };

    public colore='#1aaa55';

    public workHours: WorkHoursModel = { start: '9:00', end: '14:00' };

    public selectedDate: Date = new Date();
    
    public dataSourceActivities:any[]=[];

    public showQuickInfo: Boolean = true;
    public startDate!: Date;
    public endDate!: Date;
    public filterEventType:any;
    
    
    constructor(
      private apiService: ApiService,
      public globalService : GlobalService
    ){

    }
  
    ngOnInit(): void {
      /*
      this.apiService.get('crm/getactivities',{}).subscribe(data => {
        let wlist=[];
        let meet=[];
        data.Result.forEach((m)=>{
          if(m['status'] && m['status']!='New'){
            m['StartTime']=new Date(m['start_date']);
            m['EndTime']=new Date(m['end_date']);
            meet.push(m);
          } else {
            wlist.push(m);
          }
          
        });
        this.dataSourceActivities=meet;
        this.scheduleObj.eventSettings.dataSource=this.dataSourceActivities;
      
      });
      */
      let params= {id_user:this.globalService.loggedUser.id};
      this.apiService.get('users/logininfokpi',params).subscribe(data => {
        let params=data.Result[0];
       
        this.apiService.get('todo/tasks',params).subscribe(data => {
          let tasklist=[];
          data.Result.forEach((m)=>{
            m['StartTime']=new Date(m['data_apertura']);
            m['EndTime']=new Date(m['data_apertura']);
            tasklist.push(m);
          });
          this.eventSettings.dataSource=tasklist;
         
        });
      });
      
    }
   
    onChangeFilter(args: any): void {
      this.scheduleObj.eventSettings.dataSource=this.dataSourceActivities.filter((m)=>m.type==args.value);
    }

    onEventRendered(args: EventRenderedArgs): void {  
      
      
      let categoryColor: string ='Blue';
   
      if (!args.element || !categoryColor) { 
          return; 
      } 
   
      args.element.style.backgroundColor = categoryColor; 
     
    } 


    onPopupOpen(args: PopupOpenEventArgs): void {
      let isEmptyCell =
        args.target.classList.contains('e-work-cells') ||
        args.target.classList.contains('e-header-cells'); // checking whether the cell is empty or not
      if ((args.type === 'QuickInfo' || args.type === 'Editor') && isEmptyCell) {
          args.cancel = true;
        }
    }
 

    public startDateParser(data: string) {
        if (isNullOrUndefined(this.startDate) && !isNullOrUndefined(data)) {
          return new Date(data);
        } else if (!isNullOrUndefined(this.startDate)) {
          return new Date(this.startDate);
        }
        return new Date();
    }

    public endDateParser(data: string) {
        if (isNullOrUndefined(this.endDate) && !isNullOrUndefined(data)) {
          return new Date(data);
        } else if (!isNullOrUndefined(this.endDate)) {
          return new Date(this.endDate);
        }
        return new Date();
    }

    public onDateChange(args: ChangeEventArgs): void {
        if (!isNullOrUndefined(args.event as any)) {
          if (args.element.id === "StartTime") {
            this.startDate = args.value as Date;
          } else if (args.element.id === "EndTime") {
            this.endDate = args.value as Date;
          }
        }
    }


}
